import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import { LockEventSessionsContext } from "./LockEventSessionsContext";
import execute from "@beeldit/core/services/execute";

function useExecuteGenerateEventSessions() {
  const errorHandler = useErrorHandler();
  const { modelId, element, setBackendFormErrors } = useContext(LockEventSessionsContext);  
  return (onSuccess: any) => {
    execute(`event_sessions/lock/${modelId}`, element)
      .then((response: any) => {
        onSuccess(response.data);
      })
      .catch((error: any) => {
        console.error("Error fetching data:", error);
        errorHandler(error, setBackendFormErrors);
      });
  };
}

export default useExecuteGenerateEventSessions;
